import { TextField, FormControl, Select, InputLabel } from "@material-ui/core";
//import { ToggleButton } from "@material-ui/lab";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
//import SlidingComponent from "../../../../reusableComponents/slidingToggleComponent/SlidingComponent";
import { AmealioLoader } from "../../../../Loader/AmealioLoader";
import { useFormik } from "formik";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getFavChains } from "../../../../../store/actions/SuperAdminActions/adminCategoryAndIconsAction";
import {
  admin_create_chain_catalog,
  admin_update_chain_catalog,
} from "../../../../../store/actions/SuperAdminActions/adminCreateCatalogue";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { useHistory } from "react-router-dom";
const validate = (values) => {
  const errors = {};
  if (values.name === "") {
    errors.name = "Catalogue name is required";
  }

  if (values.restaurant_chain_id === "") {
    errors.restaurant_chain_id = "Please select chain";
  }

  return errors;
};

const AddChainCatalogue = (props) => {
  const [favChains, setFavChains] = useState([]);
  const [redirect, setRedirect] = useState(false);
  const [edit, setEdit] = useState(false);
  let history = useHistory();
  const onSuccess = () => {
    if (redirect) {
      history.push("/superadmin-global-catalogue");
    } else {
      formik.resetForm();
    }
    setEdit(false);
  };

  const onChangeChain = (e) => {
    formik.setFieldValue("restaurant_chain_id", e.target.value);
  };

  const onClickAdd = (status) => {
    setRedirect(status);
    formik.handleSubmit();
  };

  const formik = useFormik({
    initialValues: {
      restaurant_chain_id: "",
      name: "",
      description: "",
      status: false,
    },
    validate,

    onSubmit: (values) => {
      const token = props.auth.user.accessToken;
      if (edit) {
        let catalogId = values._id;
        delete values["_id"];
        props.admin_update_chain_catalog(token, values, catalogId, onSuccess);
      } else {
        props.admin_create_chain_catalog(token, values, onSuccess);
      }
    },
  });

  const onErrorGetFavChain = () => {};
  const onSuccessGetFavChain = (data) => {
    setFavChains(data);
  };
  useEffect(() => {
    props.getFavChains(onSuccessGetFavChain, onErrorGetFavChain);
  }, []);

  useEffect(() => {
    if (props.editChainCatalog.edit) {
      //      formik.setValues(props.editChainCatalog);
      formik.setFieldValue("_id", props.editChainCatalog._id);
      formik.setFieldValue("name", props.editChainCatalog.name);
      formik.setFieldValue("description", props.editChainCatalog.description);
      formik.setFieldValue("status", props.editChainCatalog.status);
      formik.setFieldValue(
        "restaurant_chain_id",
        props.editChainCatalog.restaurant_chain_id._id
      );
      setEdit(true);
    }
  }, [props.editChainCatalog]);
  return (
    <React.Fragment>
      {props.auth.loader ? (
        <AmealioLoader />
      ) : (
        <React.Fragment>
          <div className="p-4">
            <div className="f20-700">Add Chain Catalogue</div>
            <div className="mt-4">
              <div className="f16-500 mb-2">Catalogue Information</div>

              <Row>
                <FormControl variant="outlined" className="w-100">
                  <Col md={6}>
                    <InputLabel htmlFor="outlined-Category">
                      Select Chain
                    </InputLabel>
                    <Select
                      fullWidth
                      id="selected_category"
                      value={formik.values.restaurant_chain_id}
                      onChange={onChangeChain}
                      label="Select Category"
                      inputProps={{
                        name: "chain",
                        id: "outlined-Category",
                      }}
                      IconComponent={KeyboardArrowDownIcon}
                    >
                      {favChains.map((item, index) => (
                        <option value={item._id} key={index}>
                          {item.title}
                        </option>
                      ))}
                    </Select>

                    <br />
                  </Col>
                </FormControl>
              </Row>
              {formik.errors.restaurant_chain_id &&
              formik.touched.restaurant_chain_id ? (
                <div className="pho_14_regular text-danger">
                  {formik.errors.restaurant_chain_id}
                </div>
              ) : null}
              <Row className="mt-4">
                <Col md={6}>
                  <TextField
                    variant="outlined"
                    label="Catalogue Name"
                    fullWidth
                    className={`w-100 ${
                      formik.errors.name && formik.touched.name ? "enError" : ""
                    }`}
                    name="name"
                    onChange={formik.handleChange}
                    value={formik.values.name}
                    onBlur={formik.handleBlur}
                    //onInvalid={formik.errors.email && formik.touched.email}
                    isinvalid={formik.errors.name && formik.touched.name}
                  />
                  {formik.errors.name && formik.touched.name ? (
                    <div className="pho_14_regular text-danger">
                      {formik.errors.name}
                    </div>
                  ) : null}
                  <br />
                </Col>
              </Row>

              <Row className="mt-4">
                <Col md={6}>
                  <div className="mt-3">
                    <TextField
                      label="Description"
                      variant="outlined"
                      multiline={true}
                      fullWidth
                      rows={4}
                      name="description"
                      onChange={formik.handleChange}
                      value={formik.values.description}
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <div className="d-flex align-items-center pt-5">
                  <button
                    type="button"
                    className="mr-4 px-5 btn-md py-2 btn btn-outline-secondary"
                    onClick={() => history.push("/superadmin-global-catalogue")}
                  >
                    Back
                  </button>
                  <button
                    type="button"
                    className="mr-4 px-5 btn-md py-2 btn btn-danger"
                    onClick={() => onClickAdd(true)}
                  >
                    {edit ? "Edit" : "Add"}
                  </button>
                  <button
                    type="button"
                    className="px-5 btn-md py-2 btn btn-outline-danger"
                    onClick={() => onClickAdd(false)}
                  >
                    {edit ? "Edit" : "Save"} & Add Another
                  </button>
                </div>
              </Row>
            </div>
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

AddChainCatalogue.propTypes = {
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  editChainCatalog: state.commonSuperAdmin.editChainCatalog,
});

export default connect(mapStateToProps, {
  getFavChains,
  admin_create_chain_catalog,
  admin_update_chain_catalog,
})(AddChainCatalogue);
